module.exports = __webpack_public_path__ + "img/12-04.40484acc.jpg";